import React from 'react';
import useUser from '../hooks/useUser';
import ServerProductcategory from '../masters/server/Productcategory';
import ClientProductcategory from '../masters/client/Productcategory';

const CategoryMaster = () => {
    const { userRole } = useUser();

    // Get role from localStorage as fallback
    const role = userRole || localStorage.getItem('role') || '';
    const roleLower = role?.toLowerCase() || '';
    // Render based on role
    if (roleLower === 'gspos') {
        return <ServerProductcategory />;
    } else if (roleLower === 'client') {
        return <ClientProductcategory />;
    }
};

export default CategoryMaster;
